import { Link } from 'react-router-dom';

interface Stats {
  totalSupply: number;
  totalDemand: number;
  todayNew: number;
}

interface DataDashboardProps {
  stats: Stats;
}

export default function DataDashboard({ stats }: DataDashboardProps) {
  const items = [
    {
      icon: 'ri-file-list-3-line',
      value: stats.totalSupply,
      label: '总挂牌数',
      desc: '绿证供给挂牌总量',
      to: '/supply',
    },
    {
      icon: 'ri-shopping-cart-2-line',
      value: stats.totalDemand,
      label: '总求购数',
      desc: '采购需求发布总量',
      to: '/demand',
    },
    {
      icon: 'ri-flashlight-line',
      value: stats.todayNew,
      label: '最新日新增',
      desc: '最新发布日新增信息条目',
      to: '/supply?today=1',
    },
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            平台实时数据
          </h2>
        </div>

        {/* Stats cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item, idx) => (
            <Link
              key={idx}
              to={item.to}
              className="bg-background-50 rounded-lg p-8 md:p-10 flex flex-col items-start transition-shadow hover:shadow-md cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <i className={`${item.icon} text-3xl text-primary-500`}></i>
              </div>
              <div className="mt-6">
                <p className="font-heading text-5xl md:text-6xl font-bold text-foreground-900">
                  {item.value}
                </p>
                <p className="text-base font-semibold text-foreground-800 mt-2 font-label">
                  {item.label}
                </p>
                <p className="text-sm text-foreground-500 mt-1">
                  {item.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}